import styles from './IconButton.module.scss'

export enum Icon {
	EXPORT = "EXPORT"
}

export interface IconButtonProps {
	icon: Icon;
	title: string;
	onClick: () => void;
}

export const IconButton = (props: IconButtonProps) => {
	const iconClassName = iconClassNameMapping[props.icon];
	return (
		<a className={styles.button} onClick={props.onClick} href='#' title={props.title}>
			<i className={iconClassName}></i>
		</a>
	)
}

const iconClassNameMapping = {
	[Icon.EXPORT]: 'far fa-file-excel'
}